import * as React from 'react'

import { PencilIcon } from '@buffer-mono/popcorn'

import { AssetThumbnail } from '~publish/components/AssetThumbnail'
import type { AssetThumbnailActionProps } from '~publish/components/AssetThumbnail'

type EditToolButtonProps = Omit<
  AssetThumbnailActionProps,
  'label' | 'tooltip' | 'children'
> & {
  isImageTooBig?: boolean
  label?: string
}

export const EditToolButton = React.forwardRef<
  HTMLButtonElement,
  EditToolButtonProps
>(({ isImageTooBig = false, ...props }, ref) => (
  <AssetThumbnail.Action
    ref={ref}
    label="Edit Image"
    tooltip={
      isImageTooBig
        ? 'Images larger than 75MP are not supported by the editor'
        : 'Edit Image'
    }
    size="small"
    disabled={isImageTooBig}
    data-testid="edit-image-button"
    {...props}
  >
    <PencilIcon />
  </AssetThumbnail.Action>
))

EditToolButton.displayName = 'EditToolButton'
